// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import Address from "./types/address";
import SignedState from "./SignedState";

@jsonObject
export default class FinishSwap extends PerunMessage {
  @jsonMember(String) clientPubKey: string;
  @jsonMember(Address) ethClientAddress: Address;
  @jsonMember(String) steClientAddress: string;
  @jsonMember(String) codeHash: string;
  @jsonMember(SignedState) signedState: SignedState;


  constructor(clientPubKey: string, ethClientAddress: Address, steClientAddress: string, codeHash: string, signedState: SignedState) {
    super();
    this.clientPubKey = clientPubKey;
    this.ethClientAddress = ethClientAddress;
    this.codeHash = codeHash;
    this.steClientAddress = steClientAddress;
    this.signedState = signedState;
  }

  messageType(): MessageType {
    return FinishSwap;
  }

  messageTypeName(): MessageTypeName {
    return "FinishSwap";
  }
}
